import { COLOR_PALETTE } from "colors"

export enum CardType {
	TREE_MAP = "TreeMap",
	HORIZONTAL_BAR_CHART = "HorizontalBarChart",
	PIE_CHART = "PieChart",
}

export const CUSTOMER_VALUE_TREEMAP_COLORS: string[] = [
	COLOR_PALETTE.CHART_5,
	COLOR_PALETTE.CHART_4,
	COLOR_PALETTE.CHART_3,
	COLOR_PALETTE.CHART_2,
	COLOR_PALETTE.YELLOW_600,
	COLOR_PALETTE.PURPLE_600,
]

export const CHANNELS_COLORS: string[] = [
	COLOR_PALETTE.PURPLE_600,
	COLOR_PALETTE.YELLOW_600,
	COLOR_PALETTE.CHART_2,
]

export const AGE_COLORS: string[] = [
	COLOR_PALETTE.CHART_6,
	COLOR_PALETTE.CHART_5,
	COLOR_PALETTE.CHART_4,
	COLOR_PALETTE.CHART_3,
	COLOR_PALETTE.CHART_2,
	COLOR_PALETTE.YELLOW_600,
	COLOR_PALETTE.PURPLE_600,
]
export const GENDER_COLORS: string[] = [
	COLOR_PALETTE.CHART_2,
	COLOR_PALETTE.YELLOW_600,
	COLOR_PALETTE.PURPLE_600,
]

export const WHITE_COLOR = "#FFFFFF"
